var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -32 576 576",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#163B6C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#163B6C",
    d: "M528,512l-480,0c-26.51,0 -48,-21.49 -48,-48l0,-352c0,-26.501 21.476,-47.986 48,-48l144,0l0,96l192,0l0,-96l144,0c26.524,0.014 48,21.499 48,48l0,352c0,26.482 -21.445,47.955 -48,48Zm-384,-160l-13.333,0c-36.867,0.047 -66.667,29.877 -66.667,66.667c0,7.363 5.969,13.333 13.333,13.333l197.334,0c7.38,-0.017 13.333,-5.98 13.333,-13.333c0,-36.79 -29.801,-66.62 -66.667,-66.667l-13.333,0c-0.603,0.409 -16.369,11 -32,11c-15.631,0 -31.397,-10.591 -32,-11Zm360,-16l-144,0c-4.46,0.043 -8,3.608 -8,8l0,16c0,4.418 3.582,8 8,8l144,0c4.431,-0.013 8,-3.59 8,-8l0,-16c0,-4.392 -3.54,-7.957 -8,-8Zm-328,0c35.346,0 64,-28.654 64,-64c0,-35.346 -28.654,-64 -64,-64c-35.346,0 -64,28.654 -64,64c0,35.346 28.654,64 64,64Zm328,-64l-144,0c-4.46,0.043 -8,3.608 -8,8l0,16c0,4.418 3.582,8 8,8l144,0c4.431,-0.013 8,-3.59 8,-8l0,-16c0,-4.392 -3.54,-7.957 -8,-8Zm0,-64l-144,0c-4.46,0.043 -8,3.608 -8,8l0,16c0,4.418 3.582,8 8,8l144,0c4.431,-0.013 8,-3.59 8,-8l0,-16c0,-4.392 -3.54,-7.957 -8,-8Zm-152,-80l-128,0l0,-96c0,-17.673 14.327,-32 32,-32l64,0c17.673,0 32,14.327 32,32l0,96Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdBadge);
export default __webpack_public_path__ + "static/media/id_badge.61bd2997a9e17825280a14d8ae2f9eac.svg";
export { ForwardRef as ReactComponent };